import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TouchService } from '@app/core/services/touch/touch.service';

@Component({
  selector: 'app-using-non-raymarine-card',
  templateUrl: './using-non-raymarine-card.component.html',
  styleUrls: ['./using-non-raymarine-card.component.scss']
})
export class UsingNonRaymarineCardComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<UsingNonRaymarineCardComponent>,
    // this service is in-use by template, please do not remove
    public touchService: TouchService) { }

  ngOnInit() {
  }

  public ok(event) {
    event.preventDefault();

    this.dialogRef.close({});
  }
}
